var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "root",
    [
      _c("template", { slot: "content" }, [
        _c("div", { attrs: { id: "container-fluid" } }, [
          _c(
            "div",
            {
              staticClass: "row container-header container-segment",
              attrs: { id: "top-nav" }
            },
            [
              _c("div", { staticClass: "container-header-inner" }, [
                _c(
                  "div",
                  { staticClass: "header-title" },
                  [_c("app-logo-name")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header-nav" },
                  [_vm._t("page-header-right")],
                  2
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "onestore-theme-secondary" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row container-segment",
              attrs: { id: "page-main-content" }
            },
            [
              _vm._t("page-content", [
                _vm._v("\n\t\t\t\t\t--page-content--\n\t\t\t\t")
              ])
            ],
            2
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b2b435e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2b435e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/BaseLayout.vue
// module id = null
// module chunks = 